const smsLottie = (downloadAppText: string) => ({
  v: '4.8.0',
  meta: {
    g: 'LottieFiles AE ',
    a: '',
    k: '',
    d: '',
    tc: '',
  },
  fr: 24,
  ip: 0,
  op: 97,
  w: 304,
  h: 250,
  nm: 'Text message',
  ddd: 0,
  assets: [],
  fonts: {
    list: [
      {
        origin: 0,
        fPath: '',
        fClass: '',
        fFamily: 'Lato',
        fWeight: '',
        fStyle: 'Bold',
        fName: 'Lato-Bold',
        ascent: 74.2996215820312,
      },
    ],
  },
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 5,
      nm: '.downloadApp',
      cl: 'downloadApp',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {
                x: [0.667],
                y: [1],
              },
              o: {
                x: [0.333],
                y: [0],
              },
              t: 29,
              s: [0],
            },
            {
              t: 37,
              s: [100],
            },
          ],
          ix: 11,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        p: {
          a: 1,
          k: [
            {
              i: {
                x: 0.667,
                y: 1,
              },
              o: {
                x: 0.333,
                y: 0,
              },
              t: 27,
              s: [181.555, 139.199, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              t: 40,
              s: [181.555, 129.199, 0],
            },
          ],
          ix: 2,
        },
        a: {
          a: 0,
          k: [-4.945, -3.301, 0],
          ix: 1,
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6,
        },
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                sz: [129, 22.5],
                ps: [-59.5, -8],
                s: 10,
                f: 'Lato-Bold',
                t: downloadAppText,
                j: 0,
                tr: 0,
                lh: 12,
                ls: 0,
                fc: [0.11, 0.494, 0.518],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: {
          g: 1,
          a: {
            a: 0,
            k: [0, 0],
            ix: 2,
          },
        },
        a: [],
      },
      ip: 0,
      op: 240,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 2,
      ty: 5,
      nm: '.title',
      cl: 'title',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {
                x: [0.667],
                y: [1],
              },
              o: {
                x: [0.333],
                y: [0],
              },
              t: 23,
              s: [0],
            },
            {
              t: 31,
              s: [100],
            },
          ],
          ix: 11,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        p: {
          a: 1,
          k: [
            {
              i: {
                x: 0.667,
                y: 1,
              },
              o: {
                x: 0.333,
                y: 0,
              },
              t: 22,
              s: [160.586, 125.846, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              t: 33,
              s: [160.586, 112.346, 0],
            },
          ],
          ix: 2,
        },
        a: {
          a: 0,
          k: [-25.914, -3.154, 0],
          ix: 1,
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6,
        },
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                sz: [136, 12.5],
                ps: [-59.5, -8],
                s: 13,
                f: 'Lato-Bold',
                t: 'Happy Hearts',
                j: 0,
                tr: 0,
                lh: 15.6,
                ls: 0,
                fc: [0.075, 0.145, 0.208],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: {
          g: 1,
          a: {
            a: 0,
            k: [0, 0],
            ix: 2,
          },
        },
        a: [],
      },
      ip: 0,
      op: 240,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 3,
      ty: 4,
      nm: 'Check',
      parent: 4,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        p: {
          a: 0,
          k: [16.845, 18.338, 0],
          ix: 2,
        },
        a: {
          a: 0,
          k: [18.057, 15.439, 0],
          ix: 1,
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6,
        },
      },
      ao: 0,
      shapes: [
        {
          ind: 0,
          ty: 'sh',
          ix: 1,
          ks: {
            a: 0,
            k: {
              i: [
                [0, 0],
                [0, 0],
                [0, 0],
              ],
              o: [
                [0, 0],
                [0, 0],
                [0, 0],
              ],
              v: [
                [10, 15.642],
                [15.236, 20.878],
                [28.489, 7.5],
              ],
              c: false,
            },
            ix: 2,
          },
          nm: 'Path 1',
          mn: 'ADBE Vector Shape - Group',
          hd: false,
        },
        {
          ty: 'st',
          c: {
            a: 0,
            k: [1, 1, 1, 1],
            ix: 3,
          },
          o: {
            a: 0,
            k: 100,
            ix: 4,
          },
          w: {
            a: 0,
            k: 4,
            ix: 5,
          },
          lc: 2,
          lj: 2,
          bm: 0,
          nm: 'Stroke 1',
          mn: 'ADBE Vector Graphic - Stroke',
          hd: false,
        },
        {
          ty: 'tm',
          s: {
            a: 0,
            k: 0,
            ix: 1,
          },
          e: {
            a: 1,
            k: [
              {
                i: {
                  x: [0.667],
                  y: [1],
                },
                o: {
                  x: [0.333],
                  y: [0],
                },
                t: 39,
                s: [0],
              },
              {
                t: 50,
                s: [87],
              },
            ],
            ix: 2,
          },
          o: {
            a: 0,
            k: 0,
            ix: 3,
          },
          m: 1,
          ix: 3,
          nm: 'Trim Paths 1',
          mn: 'ADBE Vector Filter - Trim',
          hd: false,
        },
      ],
      ip: 0,
      op: 240,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 4,
      ty: 4,
      nm: 'Check BG',
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        p: {
          a: 0,
          k: [260.154, 94.872, 0],
          ix: 2,
        },
        a: {
          a: 0,
          k: [16.845, 16.845, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              i: {
                x: [0.667, 0.667, 0.667],
                y: [1, 1, 1],
              },
              o: {
                x: [0.333, 0.333, 0.333],
                y: [0, 0, 0],
              },
              t: 33,
              s: [0, 0, 100],
            },
            {
              i: {
                x: [0.667, 0.667, 0.667],
                y: [1, 1, 1],
              },
              o: {
                x: [0.333, 0.333, 0.333],
                y: [0, 0, 0],
              },
              t: 41,
              s: [115, 115, 100],
            },
            {
              t: 50,
              s: [100, 100, 100],
            },
          ],
          ix: 6,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-9.166, 0],
                    [0, 9.166],
                    [9.165, 0],
                    [0, -9.165],
                  ],
                  o: [
                    [9.165, 0],
                    [0, -9.165],
                    [-9.166, 0],
                    [0, 9.166],
                  ],
                  v: [
                    [0.001, 16.596],
                    [16.596, -0.001],
                    [0.001, -16.596],
                    [-16.596, -0.001],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.968627510819, 0.023529413635, 0.882353001015, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [16.845, 16.845],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 240,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 5,
      ty: 4,
      nm: 'Talk bubble',
      parent: 6,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
        r: {
          a: 1,
          k: [
            {
              i: {
                x: [0.667],
                y: [1],
              },
              o: {
                x: [0.333],
                y: [0],
              },
              t: 23,
              s: [-20],
            },
            {
              i: {
                x: [0.667],
                y: [1],
              },
              o: {
                x: [0.333],
                y: [0],
              },
              t: 33,
              s: [5],
            },
            {
              t: 44,
              s: [0],
            },
          ],
          ix: 10,
        },
        p: {
          a: 0,
          k: [17.016, 44.381, 0],
          ix: 2,
        },
        a: {
          a: 0,
          k: [6.754, 27.178, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              i: {
                x: [0.667, 0.667, 0.667],
                y: [1, 1, 1],
              },
              o: {
                x: [0.333, 0.333, 0.333],
                y: [0, 0, 0],
              },
              t: 23,
              s: [0, 0, 100],
            },
            {
              i: {
                x: [0.667, 0.667, 0.667],
                y: [1, 1, 1],
              },
              o: {
                x: [0.333, 0.333, 0.333],
                y: [0, 0, 0],
              },
              t: 33,
              s: [100, 100, 100],
            },
            {
              t: 44,
              s: [95.238, 95.238, 100],
            },
          ],
          ix: 6,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0.001, 0.012],
                    [0.314, 0.47],
                    [0.031, 0.043],
                    [0.077, 0.062],
                    [0.3, 0],
                    [0.26, -0.299],
                    [0, 0],
                    [0, 0],
                    [-0.438, -0.29],
                    [-0.183, 0.001],
                    [-0.168, 0.192],
                    [0, 0],
                    [-0.106, -0.085],
                    [0, 0],
                    [0.089, -0.101],
                    [0, 0],
                    [0.423, -0.035],
                    [0.046, 0],
                    [0.288, 0.232],
                    [-0.562, 0.642],
                    [0, 0],
                    [0, 0],
                    [-0.456, 0.075],
                    [0.555, -0.011],
                    [0.521, -1.325],
                    [0.026, 0],
                    [0.018, 0.048],
                    [1.525, 0.033],
                    [0.172, -1.822],
                    [-2.142, -1.431],
                    [-0.837, 0.559],
                    [0.272, 3.222],
                  ],
                  o: [
                    [-0.002, -0.013],
                    [-0.055, -0.592],
                    [-0.029, -0.043],
                    [-0.06, -0.073],
                    [-0.247, -0.199],
                    [-0.376, 0],
                    [0, 0],
                    [0, 0],
                    [-0.334, 0.382],
                    [0.151, 0.101],
                    [0.265, -0.004],
                    [0, 0],
                    [0.089, -0.102],
                    [0, 0],
                    [0.105, 0.086],
                    [0, 0],
                    [-0.272, 0.311],
                    [-0.047, 0.004],
                    [-0.371, 0],
                    [-0.669, -0.54],
                    [0, 0],
                    [0, 0],
                    [0.319, -0.365],
                    [-0.476, -0.22],
                    [-1.524, 0.033],
                    [-0.019, 0.048],
                    [-0.026, 0],
                    [-0.521, -1.325],
                    [-1.855, -0.038],
                    [-0.304, 3.235],
                    [0.836, 0.559],
                    [2.133, -1.425],
                    [0, 0],
                  ],
                  v: [
                    [7.077, -2.475],
                    [7.074, -2.51],
                    [6.5, -4.12],
                    [6.411, -4.249],
                    [6.207, -4.454],
                    [5.358, -4.749],
                    [4.348, -4.296],
                    [3.376, -3.186],
                    [0.915, -0.368],
                    [1.093, 0.887],
                    [1.607, 1.038],
                    [2.283, 0.731],
                    [4.777, -2.122],
                    [5.131, -2.152],
                    [5.278, -2.034],
                    [5.309, -1.695],
                    [2.814, 1.16],
                    [1.737, 1.697],
                    [1.597, 1.703],
                    [0.58, 1.348],
                    [0.385, -0.797],
                    [1.827, -2.448],
                    [3.817, -4.723],
                    [5.022, -5.387],
                    [3.462, -5.714],
                    [0.075, -3.445],
                    [0.014, -3.387],
                    [-0.047, -3.445],
                    [-3.435, -5.714],
                    [-7.047, -2.51],
                    [-1.375, 5.193],
                    [1.405, 5.193],
                    [7.079, -2.476],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [1, 1, 1, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [16.492, 11.71],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [-2.536, 0],
                  ],
                  o: [
                    [0, -2.778],
                    [0, 0],
                  ],
                  v: [
                    [-1.616, 2.262],
                    [1.616, -2.262],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'st',
              c: {
                a: 0,
                k: [1, 1, 1, 1],
                ix: 3,
              },
              o: {
                a: 0,
                k: 100,
                ix: 4,
              },
              w: {
                a: 0,
                k: 1,
                ix: 5,
              },
              lc: 2,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: 'Stroke 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [4.905, 4.268],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 2',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0.005, -1.917],
                    [0, 0],
                    [1.917, 0],
                    [0, 0],
                    [0.24, -0.261],
                    [0, 0],
                    [-0.003, 1.148],
                    [0, 0],
                    [0.55, 0],
                    [-0.005, 1.917],
                    [0, 0],
                    [-1.917, 0],
                  ],
                  o: [
                    [1.917, 0],
                    [0, 0],
                    [-0.005, 1.917],
                    [0, 0],
                    [-0.353, 0],
                    [0, 0],
                    [-0.778, 0.847],
                    [0, 0],
                    [0.001, -0.55],
                    [-1.916, 0.001],
                    [0, 0],
                    [0.005, -1.916],
                    [0, 0],
                  ],
                  v: [
                    [11.549, -13.307],
                    [15.012, -9.837],
                    [14.971, 5.262],
                    [11.492, 8.734],
                    [-4.405, 8.738],
                    [-5.335, 9.146],
                    [-8.378, 12.46],
                    [-10.562, 11.609],
                    [-10.558, 9.734],
                    [-11.551, 8.738],
                    [-15.012, 5.268],
                    [-14.971, -9.831],
                    [-11.492, -13.301],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.956862804936, 0.133333333333, 0.274509803922, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [16.506, 13.556],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 3',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0.005, -1.917],
                    [0, 0],
                    [1.917, 0],
                    [0, 0],
                    [0.24, -0.261],
                    [0, 0],
                    [-0.003, 1.148],
                    [0, 0],
                    [0.55, 0],
                    [-0.005, 1.917],
                    [0, 0],
                    [-1.374, 0.463],
                    [-0.388, 0],
                  ],
                  o: [
                    [1.917, 0],
                    [0, 0],
                    [-0.005, 1.917],
                    [0, 0],
                    [-0.353, 0],
                    [0, 0],
                    [-0.778, 0.847],
                    [0, 0],
                    [0.001, -0.55],
                    [-1.916, 0.001],
                    [0, 0],
                    [0.004, -1.528],
                    [0.349, -0.118],
                    [0, 0],
                  ],
                  v: [
                    [11.549, -13.307],
                    [15.012, -9.837],
                    [14.971, 5.262],
                    [11.492, 8.734],
                    [-4.405, 8.738],
                    [-5.335, 9.146],
                    [-8.378, 12.46],
                    [-10.562, 11.609],
                    [-10.558, 9.734],
                    [-11.551, 8.738],
                    [-15.012, 5.268],
                    [-14.971, -9.831],
                    [-12.603, -13.12],
                    [-11.492, -13.301],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.956862804936, 0.133333333333, 0.274509803922, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [16.506, 13.556],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 4',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 4,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [1.917, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0.004, -1.532],
                    [0, 0],
                    [-1.917, 0],
                    [0.002, -0.662],
                    [0, 0],
                    [-0.778, 0.847],
                    [0, 0],
                    [-0.353, 0],
                    [0, 0],
                    [-0.006, 1.916],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-1.378, 0.461],
                    [0, 0],
                    [-0.004, 1.917],
                    [0.662, -0.001],
                    [0, 0],
                    [-0.003, 1.149],
                    [0, 0],
                    [0.239, -0.261],
                    [0, 0],
                    [1.917, 0],
                    [0, 0],
                    [0.004, -1.917],
                  ],
                  v: [
                    [12.238, -13.814],
                    [-11.967, -13.809],
                    [-12.049, -14.089],
                    [-13.253, -13.638],
                    [-13.273, -13.615],
                    [-15.656, -10.337],
                    [-15.699, 5.77],
                    [-12.238, 9.242],
                    [-11.042, 10.439],
                    [-11.046, 12.391],
                    [-8.861, 13.242],
                    [-5.561, 9.648],
                    [-4.632, 9.24],
                    [12.176, 9.235],
                    [15.656, 5.764],
                    [15.699, -10.344],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.776470648074, 0, 0.172549019608, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [15.954, 14.525],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 5',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 5,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 240,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 6,
      ty: 4,
      nm: 'Notification BG',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {
                x: [0.667],
                y: [1],
              },
              o: {
                x: [0.333],
                y: [0],
              },
              t: 11,
              s: [0],
            },
            {
              t: 23,
              s: [100],
            },
          ],
          ix: 11,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        p: {
          a: 0,
          k: [74.604, 146.23, 0],
          ix: 2,
        },
        a: {
          a: 0,
          k: [-2.971, 56.827, 0],
          ix: 1,
        },
        s: {
          a: 1,
          k: [
            {
              i: {
                x: [0.667, 0.667, 0.667],
                y: [1, 1, 1],
              },
              o: {
                x: [0.333, 0.333, 0.333],
                y: [0, 0, 0],
              },
              t: 8,
              s: [0, 0, 100],
            },
            {
              i: {
                x: [0.667, 0.667, 0.667],
                y: [1, 1, 1],
              },
              o: {
                x: [0.333, 0.333, 0.333],
                y: [0, 0, 0],
              },
              t: 23,
              s: [105, 105, 100],
            },
            {
              t: 31,
              s: [100, 100, 100],
            },
          ],
          ix: 6,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [5.623, 0],
                    [0, 0],
                    [0, -5.334],
                    [0, 0],
                    [-5.622, 0],
                    [0, 0],
                    [0, 5.333],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [-5.622, 0],
                    [0, 0],
                    [0, 5.333],
                    [0, 0],
                    [5.623, 0],
                    [0, 0],
                    [0, -5.334],
                  ],
                  v: [
                    [84.654, -29.691],
                    [-84.654, -29.691],
                    [-94.833, -20.034],
                    [-94.592, 23.534],
                    [-84.412, 33.191],
                    [84.895, 33.191],
                    [95.075, 23.534],
                    [94.833, -20.034],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [1, 1, 1, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [95.084, 29.941],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 240,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 7,
      ty: 4,
      nm: 'Notification shadow',
      parent: 6,
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {
                x: [0.667],
                y: [1],
              },
              o: {
                x: [0.333],
                y: [0],
              },
              t: 20,
              s: [0],
            },
            {
              t: 27,
              s: [30],
            },
          ],
          ix: 11,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        p: {
          a: 1,
          k: [
            {
              i: {
                x: 0.667,
                y: 1,
              },
              o: {
                x: 0.333,
                y: 0,
              },
              t: 20,
              s: [83.576, 34.701, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: {
                x: 0.667,
                y: 0.667,
              },
              o: {
                x: 0.167,
                y: 0.167,
              },
              t: 31,
              s: [76.91, 43.273, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              t: 57,
              s: [76.91, 43.273, 0],
            },
          ],
          ix: 2,
        },
        a: {
          a: 0,
          k: [86.857, 28.805, 0],
          ix: 1,
        },
        s: {
          a: 0,
          k: [95.238, 95.238, 100],
          ix: 6,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [5.334, 0],
                    [0, 0],
                    [0, -5.333],
                    [0, 0],
                    [-5.334, 0],
                    [0, 0],
                    [0, 5.333],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [-5.334, 0],
                    [0, 0],
                    [0, 5.333],
                    [0, 0],
                    [5.334, 0],
                    [0, 0],
                    [0, -5.333],
                  ],
                  v: [
                    [77.2, -28.805],
                    [-77.2, -28.805],
                    [-86.857, -19.148],
                    [-86.857, 19.148],
                    [-77.2, 28.805],
                    [77.2, 28.805],
                    [86.857, 19.148],
                    [86.857, -19.148],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.552941176471, 0.61568627451, 0.686274509804, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [86.857, 28.806],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 240,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 8,
      ty: 4,
      nm: 'Lines',
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        p: {
          a: 0,
          k: [57.299, 28.213, 0],
          ix: 2,
        },
        a: {
          a: 0,
          k: [22.318, 16.001, 0],
          ix: 1,
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [7.534, 4.432],
                    [-7.534, -4.432],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'st',
              c: {
                a: 0,
                k: [0.956862804936, 0.133333333333, 0.274509803922, 1],
                ix: 3,
              },
              o: {
                a: 0,
                k: 100,
                ix: 4,
              },
              w: {
                a: 0,
                k: 4,
                ix: 5,
              },
              lc: 2,
              lj: 2,
              bm: 0,
              nm: 'Stroke 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [9.534, 13.056],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [1.773, 4.432],
                    [-1.773, -4.432],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'st',
              c: {
                a: 0,
                k: [0.956862804936, 0.133333333333, 0.274509803922, 1],
                ix: 3,
              },
              o: {
                a: 0,
                k: 100,
                ix: 4,
              },
              w: {
                a: 0,
                k: 4,
                ix: 5,
              },
              lc: 2,
              lj: 2,
              bm: 0,
              nm: 'Stroke 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [20.798, 6.432],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 2',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'tm',
          s: {
            a: 0,
            k: 0,
            ix: 1,
          },
          e: {
            a: 1,
            k: [
              {
                i: {
                  x: [0.667],
                  y: [1],
                },
                o: {
                  x: [0.333],
                  y: [0],
                },
                t: 16,
                s: [0],
              },
              {
                t: 21,
                s: [100],
              },
            ],
            ix: 2,
          },
          o: {
            a: 0,
            k: 0,
            ix: 3,
          },
          m: 1,
          ix: 3,
          nm: 'Trim Paths 1',
          mn: 'ADBE Vector Filter - Trim',
          hd: false,
        },
      ],
      ip: 16,
      op: 245,
      st: 5,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 9,
      ty: 4,
      nm: 'PHONE MASK',
      parent: 11,
      td: 1,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        p: {
          a: 0,
          k: [158.084, 137.437, 0],
          ix: 2,
        },
        a: {
          a: 0,
          k: [156.938, 134.456, 0],
          ix: 1,
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [37.335, -58.582],
                    [-71.953, -35.677],
                    [-41.367, 52.456],
                    [43.677, 24.783],
                  ],
                  o: [
                    [-52.126, -27.421],
                    [-40.668, 56.178],
                    [57.762, 29.018],
                    [41.368, -52.467],
                    [0, 0],
                  ],
                  v: [
                    [101.23, -101.004],
                    [-126.329, -80.474],
                    [-70.238, 109.337],
                    [111.01, 41.96],
                    [101.23, -100.993],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0, 0, 1, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [161.247, 130.306],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 240,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 10,
      ty: 4,
      nm: 'Phone',
      tt: 1,
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        p: {
          a: 1,
          k: [
            {
              i: {
                x: 0.667,
                y: 1,
              },
              o: {
                x: 0.333,
                y: 0,
              },
              t: 0,
              s: [137.864, 206.721, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: {
                x: 0.224,
                y: 1,
              },
              o: {
                x: 0.333,
                y: 0,
              },
              t: 11,
              s: [137.864, 162.721, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              t: 27,
              s: [137.864, 170.721, 0],
            },
          ],
          ix: 2,
        },
        a: {
          a: 0,
          k: [87.086, 149.212, 0],
          ix: 1,
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [-18.643, 0],
                  ],
                  o: [
                    [-1.773, -21.87],
                    [0, 0],
                  ],
                  v: [
                    [-11.301, 19.003],
                    [13.074, -19.003],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'st',
              c: {
                a: 0,
                k: [1, 1, 1, 1],
                ix: 3,
              },
              o: {
                a: 0,
                k: 100,
                ix: 4,
              },
              w: {
                a: 0,
                k: 2,
                ix: 5,
              },
              lc: 2,
              lj: 2,
              bm: 0,
              nm: 'Stroke 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [18.075, 25.706],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-5.087, 0],
                    [0, 0],
                    [0, 5.087],
                    [0, 0],
                    [5.087, 0],
                    [0, 0],
                    [0, -5.087],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [5.087, 0],
                    [0, 0],
                    [0, -5.087],
                    [0, 0],
                    [-5.087, 0],
                    [0, 0],
                    [0, 5.087],
                  ],
                  v: [
                    [-8.711, 17.922],
                    [8.711, 17.922],
                    [17.921, 8.711],
                    [17.921, -8.711],
                    [8.711, -17.922],
                    [-8.711, -17.922],
                    [-17.922, -8.711],
                    [-17.922, 8.711],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.945098099054, 0.941176530427, 0.917647118662, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [133.34, 64.631],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 2',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-5.087, 0],
                    [0, 0],
                    [0, 5.087],
                    [0, 0],
                    [5.087, 0],
                    [0, 0],
                    [0, -5.087],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [5.087, 0],
                    [0, 0],
                    [0, -5.087],
                    [0, 0],
                    [-5.087, 0],
                    [0, 0],
                    [0, 5.087],
                  ],
                  v: [
                    [-8.711, 17.921],
                    [8.711, 17.921],
                    [17.921, 8.71],
                    [17.921, -8.711],
                    [8.711, -17.922],
                    [-8.711, -17.922],
                    [-17.922, -8.711],
                    [-17.922, 8.71],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.945098099054, 0.941176530427, 0.917647118662, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [133.34, 204.058],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 3',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-5.087, 0],
                    [0, 0],
                    [0, 5.087],
                    [0, 0],
                    [5.087, 0],
                    [0, 0],
                    [0, -5.087],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [5.087, 0],
                    [0, 0],
                    [0, -5.087],
                    [0, 0],
                    [-5.087, 0],
                    [0, 0],
                    [0, 5.087],
                  ],
                  v: [
                    [-8.711, 17.921],
                    [8.712, 17.921],
                    [17.922, 8.71],
                    [17.922, -8.711],
                    [8.712, -17.922],
                    [-8.711, -17.922],
                    [-17.922, -8.711],
                    [-17.922, 8.71],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.945098099054, 0.941176530427, 0.917647118662, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [87.543, 204.058],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 4',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 4,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-5.087, 0],
                    [0, 0],
                    [0, 5.087],
                    [0, 0],
                    [5.087, 0],
                    [0, 0],
                    [0, -5.087],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [5.087, 0],
                    [0, 0],
                    [0, -5.087],
                    [0, 0],
                    [-5.087, 0],
                    [0, 0],
                    [0, 5.087],
                  ],
                  v: [
                    [-8.71, 17.921],
                    [8.712, 17.921],
                    [17.921, 8.71],
                    [17.921, -8.711],
                    [8.712, -17.922],
                    [-8.71, -17.922],
                    [-17.921, -8.711],
                    [-17.921, 8.71],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.945098099054, 0.941176530427, 0.917647118662, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [41.747, 204.058],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 5',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 5,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-5.087, 0],
                    [0, 0],
                    [0, 5.087],
                    [0, 0],
                    [5.087, 0],
                    [0, 0],
                    [0, -5.087],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [5.087, 0],
                    [0, 0],
                    [0, -5.087],
                    [0, 0],
                    [-5.087, 0],
                    [0, 0],
                    [0, 5.087],
                  ],
                  v: [
                    [-8.711, 17.921],
                    [8.711, 17.921],
                    [17.921, 8.711],
                    [17.921, -8.71],
                    [8.711, -17.921],
                    [-8.711, -17.921],
                    [-17.922, -8.71],
                    [-17.922, 8.711],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.945098099054, 0.941176530427, 0.917647118662, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [133.34, 110.803],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 6',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 6,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-5.087, 0],
                    [0, 0],
                    [0, 5.087],
                    [0, 0],
                    [5.087, 0],
                    [0, 0],
                    [0, -5.087],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [5.087, 0],
                    [0, 0],
                    [0, -5.087],
                    [0, 0],
                    [-5.087, 0],
                    [0, 0],
                    [0, 5.087],
                  ],
                  v: [
                    [-8.711, 17.922],
                    [8.711, 17.922],
                    [17.921, 8.711],
                    [17.921, -8.71],
                    [8.711, -17.921],
                    [-8.711, -17.921],
                    [-17.922, -8.71],
                    [-17.922, 8.711],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.945098099054, 0.941176530427, 0.917647118662, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [133.34, 156.975],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 7',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 7,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-5.087, 0],
                    [0, 0],
                    [0, 5.087],
                    [0, 0],
                    [5.087, 0],
                    [0, 0],
                    [0, -5.087],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [5.087, 0],
                    [0, 0],
                    [0, -5.087],
                    [0, 0],
                    [-5.087, 0],
                    [0, 0],
                    [0, 5.087],
                  ],
                  v: [
                    [-8.711, 17.922],
                    [8.712, 17.922],
                    [17.922, 8.711],
                    [17.922, -8.711],
                    [8.712, -17.922],
                    [-8.711, -17.922],
                    [-17.922, -8.711],
                    [-17.922, 8.711],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.945098099054, 0.941176530427, 0.917647118662, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [87.543, 64.631],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 8',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 8,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-5.087, 0],
                    [0, 0],
                    [0, 5.087],
                    [0, 0],
                    [5.087, 0],
                    [0, 0],
                    [0, -5.087],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [5.087, 0],
                    [0, 0],
                    [0, -5.087],
                    [0, 0],
                    [-5.087, 0],
                    [0, 0],
                    [0, 5.087],
                  ],
                  v: [
                    [-8.711, 17.921],
                    [8.712, 17.921],
                    [17.922, 8.711],
                    [17.922, -8.71],
                    [8.712, -17.921],
                    [-8.711, -17.921],
                    [-17.922, -8.71],
                    [-17.922, 8.711],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.945098099054, 0.941176530427, 0.917647118662, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [87.543, 110.803],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 9',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 9,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-5.087, 0],
                    [0, 0],
                    [0, 5.087],
                    [0, 0],
                    [5.087, 0],
                    [0, 0],
                    [0, -5.087],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [5.087, 0],
                    [0, 0],
                    [0, -5.087],
                    [0, 0],
                    [-5.087, 0],
                    [0, 0],
                    [0, 5.087],
                  ],
                  v: [
                    [-8.71, 17.922],
                    [8.712, 17.922],
                    [17.921, 8.711],
                    [17.921, -8.71],
                    [8.712, -17.921],
                    [-8.71, -17.921],
                    [-17.921, -8.71],
                    [-17.921, 8.711],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.945098099054, 0.941176530427, 0.917647118662, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [41.747, 156.975],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 10',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 10,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-5.087, 0],
                    [0, 0],
                    [0, 5.087],
                    [0, 0],
                    [5.087, 0],
                    [0, 0],
                    [0, -5.087],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [5.087, 0],
                    [0, 0],
                    [0, -5.087],
                    [0, 0],
                    [-5.087, 0],
                    [0, 0],
                    [0, 5.087],
                  ],
                  v: [
                    [-8.711, 17.922],
                    [8.712, 17.922],
                    [17.922, 8.711],
                    [17.922, -8.71],
                    [8.712, -17.921],
                    [-8.711, -17.921],
                    [-17.922, -8.71],
                    [-17.922, 8.711],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.945098099054, 0.941176530427, 0.917647118662, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [87.543, 156.975],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 11',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 11,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-5.087, 0],
                    [0, 0],
                    [0, 5.087],
                    [0, 0],
                    [5.087, 0],
                    [0, 0],
                    [0, -5.087],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [5.087, 0],
                    [0, 0],
                    [0, -5.087],
                    [0, 0],
                    [-5.087, 0],
                    [0, 0],
                    [0, 5.087],
                  ],
                  v: [
                    [-8.71, 17.922],
                    [8.712, 17.922],
                    [17.921, 8.711],
                    [17.921, -8.711],
                    [8.712, -17.922],
                    [-8.71, -17.922],
                    [-17.921, -8.711],
                    [-17.921, 8.711],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.945098099054, 0.941176530427, 0.917647118662, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [41.747, 64.631],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 12',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 12,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-5.087, 0],
                    [0, 0],
                    [0, 5.087],
                    [0, 0],
                    [5.087, 0],
                    [0, 0],
                    [0, -5.087],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [5.087, 0],
                    [0, 0],
                    [0, -5.087],
                    [0, 0],
                    [-5.087, 0],
                    [0, 0],
                    [0, 5.087],
                  ],
                  v: [
                    [-8.71, 17.921],
                    [8.712, 17.921],
                    [17.921, 8.711],
                    [17.921, -8.71],
                    [8.712, -17.921],
                    [-8.71, -17.921],
                    [-17.921, -8.71],
                    [-17.921, 8.711],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.945098099054, 0.941176530427, 0.917647118662, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [41.747, 110.803],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 13',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 13,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [1.1, 0.007],
                    [0, 0],
                    [-0.007, 1.1],
                    [-1.101, -0.007],
                    [0, 0],
                    [0.008, -1.1],
                  ],
                  o: [
                    [0, 0],
                    [-1.125, -0.004],
                    [0.007, -1.1],
                    [0, 0],
                    [1.127, 0.004],
                    [-0.007, 1.1],
                  ],
                  v: [
                    [12.918, 1.944],
                    [-12.893, 2.083],
                    [-14.919, 0.082],
                    [-12.917, -1.944],
                    [12.892, -2.083],
                    [14.918, -0.082],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.968627510819, 0.968627510819, 0.952941236309, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [87.544, 16.641],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'notch',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 14,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [14.328, -0.093],
                    [0, 0],
                    [0.061, 9.675],
                    [0, 0],
                    [-9.674, 0.062],
                    [0, 0],
                    [0, 0],
                    [-5.281, 0.038],
                    [0, 0],
                    [0.039, 5.281],
                    [0, 0],
                    [0, 0],
                    [-0.029, -7.324],
                    [0, 0],
                  ],
                  o: [
                    [0.067, 14.332],
                    [0, 0],
                    [-9.674, 0.061],
                    [0, 0],
                    [-0.061, -9.675],
                    [0, 0],
                    [0, 0],
                    [0.035, 5.255],
                    [0, 0],
                    [5.255, -0.035],
                    [0, 0],
                    [0, 0],
                    [7.324, -0.029],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [74.152, 144.968],
                    [48.318, 171.071],
                    [-55.375, 171.584],
                    [-72.977, 154.17],
                    [-74.162, -83.786],
                    [-56.749, -101.389],
                    [-36.908, -101.505],
                    [-36.886, -96.536],
                    [-27.3, -87.059],
                    [29.03, -87.351],
                    [38.507, -96.937],
                    [38.484, -101.906],
                    [59.597, -102.002],
                    [72.936, -88.797],
                    [74.097, 144.95],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ind: 1,
              ty: 'sh',
              ix: 2,
              ks: {
                a: 0,
                k: {
                  i: [
                    [23.429, 0],
                    [0, 0],
                    [-0.08, -16.345],
                    [0, 0],
                    [-16.345, 0.08],
                    [0, 0],
                    [0.09, 21.028],
                    [0, 0],
                  ],
                  o: [
                    [-32.53, 0],
                    [-16.345, 0.08],
                    [0, 0],
                    [0.08, 16.345],
                    [0, 0],
                    [21.025, -0.115],
                    [0, 0],
                    [0, -17.835],
                  ],
                  v: [
                    [56.088, -114.089],
                    [-56.801, -113.498],
                    [-86.271, -83.734],
                    [-85.086, 154.223],
                    [-55.322, 183.693],
                    [48.37, 183.18],
                    [86.261, 144.915],
                    [85.1, -84.524],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 2',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.01568627451, 0.454901960784, 0.478431372549, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [87.549, 114.401],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'frame',
          np: 3,
          cix: 2,
          bm: 0,
          ix: 15,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0.08, 16.345],
                    [0, 0],
                    [-16.344, 0.079],
                    [0, 0],
                    [-0.076, -14.017],
                    [0, 0],
                    [21.025, -0.116],
                  ],
                  o: [
                    [0, 0],
                    [-16.345, 0.08],
                    [0, 0],
                    [-0.08, -16.346],
                    [0, 0],
                    [14.015, -0.077],
                    [0, 0],
                    [0.112, 20.999],
                    [0, 0],
                  ],
                  v: [
                    [48.359, 183.204],
                    [-55.359, 183.72],
                    [-85.094, 154.273],
                    [-86.286, -83.735],
                    [-56.839, -113.47],
                    [59.592, -114.043],
                    [85.088, -88.807],
                    [86.254, 144.965],
                    [48.385, 183.201],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.968627510819, 0.968627510819, 0.952941236309, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [87.556, 114.37],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 16',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 16,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 240,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 11,
      ty: 4,
      nm: 'Blob',
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        p: {
          a: 0,
          k: [147.119, 128.229, 0],
          ix: 2,
        },
        a: {
          a: 0,
          k: [157.512, 135.741, 0],
          ix: 1,
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [42.946, -53.3],
                    [-56.731, -28.46],
                    [-41.378, 52.393],
                    [43.688, 24.753],
                  ],
                  o: [
                    [-56.325, -31.914],
                    [-40.678, 56.11],
                    [57.778, 28.984],
                    [41.379, -52.403],
                    [0, 0],
                  ],
                  v: [
                    [101.22, -100.736],
                    [-121.465, -43.325],
                    [-70.294, 109.348],
                    [111.002, 42.053],
                    [101.22, -100.725],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.027450982262, 0.929411824544, 0.901960844152, 1],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [162.393, 132.9],
                ix: 2,
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1,
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 240,
      st: 0,
      bm: 0,
    },
  ],
  markers: [],
});

export default smsLottie;
